type CareplanOrderStatusInput = {
  hasCart: boolean;
  isCartError: boolean;
  isSellingPlansError: boolean;
  cartCreationFailed: boolean;
};

export const getCareplanOrderStatus = ({
  cartCreationFailed,
  hasCart,
  isCartError,
  isSellingPlansError,
}: CareplanOrderStatusInput) => {
  const isError = isCartError || cartCreationFailed || (!hasCart && isSellingPlansError);

  return { isLoading: !hasCart && !isError, isError };
};
